import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { SecureImageModule } from "src/app/ui-widgets/secure-image/secure-image.module";
import { HeaderModule } from "src/app/ui-widgets/header/header.module";
import { SidebarModule } from "src/app/ui-widgets/sidebar/sidebar.module";
import { TelehealthConsentComponent } from "./telehealth-consent.component";
import { NgxMaskModule } from "ngx-mask";
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { SidebarEmptyModule } from "src/app/ui-widgets/sidebar-empty/sidebar-empty-module";
import { SignatureModule } from "src/app/ui-widgets/signature-form/signature-form.module";
import { TelehealthConsentRoutingModule } from "./telehealth-consent-routing-module";

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    HeaderModule,
    FormsModule,
    ReactiveFormsModule,
    SidebarModule,
    SidebarEmptyModule,
    SecureImageModule,
    NgxMaskModule.forRoot(),
    NgxUiLoaderModule,
    SidebarModule,
    SignatureModule,
    TelehealthConsentRoutingModule
  ],
  declarations: [
    TelehealthConsentComponent
  ],
  exports: [
    TelehealthConsentComponent,
]
})
export class TelehealthConsentModule { }
